<template>
  <div>
    <a class="btn text-themed go-back" @click="goBack()">{{ $t("flexben.general.go_back") }}</a>
    <div class="row">
      <div class="col-12 col-md-6 flexben-page-title">
        <h1>{{ (formAction === 'create') ? $t('flexben.brand.new') : $t('flexben.brand.edit') }}</h1>
      </div>
      <div class="col-12 col-md-6 text-right">
        <button class="btn text-danger px-4" v-if="(formAction === 'update')" @click="modalAct('delete')">
          <font-awesome-icon icon="trash-alt"/>
          {{$t("flexben.general.btn.delete")}}
        </button>
        <button class="btn btn-themed px-4" @click="modalAct('form_submit')">
          {{ $t('flexben.general.btn.save') }}
        </button>
      </div>
    </div>
    <div class="row my-1" v-if="checkNotEmptyObj(errorsBag)">
      <div class="col-12">
        <div class="alert alert-danger alert-dismissible mb-0">
          <button type="button" class="close" data-dismiss="alert">&times;</button>
          <form-error-list :errorBag="errorsBag" />
        </div>
      </div>
    </div>
    <div class="container-bg-white mt-3">
      <div class="row px-3">
        <div class="col-12">
          <h3 class="m-0 pl-0">{{ $t('flexben.general.details') }}</h3>
        </div>
        <div class="col-12 col-xl-4 d-flex align-items-start justify-content-center mb-1">
          <div class="image-container cursor-pointer d-flex align-items-center" @click="$refs.image_input.click()">
            <div class="image-changed" v-if="imageChanged">{{$t("flexben.benefit.image_changed")}}</div>
            <img
              v-if="formData.image || formData.image_url"
              class="img-fluid upload-image"
              :alt="formData.name"
              :src="(formData.image !== null) ? imagePreview : formData.image_url"
              :class="{'img-border-danger':(Object.keys(errorsBag).includes('image'))}"
            />
            <div class="upload-image-middle-container">
              <div class="upload-image-text">{{$t("flexben.benefit.upload_image")}}</div>
            </div>
            <input type="file" class="hide" ref="image_input" accept=".png,.jpeg,.jpg,.svg,.jfif" @change="setImageFile($event)" />
          </div>
        </div>
        <div class="col-12 col-xl-8">
          <div class="row">
            <div class="col-12 col-md-6 form-group">
              <label for="name" class="form-fields-required col-form-label">
                {{ $t('flexben.brand.fields.name') }}
              </label>
              <input type="text" class="form-control" id="name" v-model="formData.name"
                :class="{'border-danger':(Object.keys(errorsBag).includes('name'))}"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="site" class="col-form-label">{{ $t('flexben.brand.fields.website') }}</label>
              <input
                type="text"
                class="form-control"
                id="site"
                v-model="formData.website"
                :class="{'border-danger':(Object.keys(errorsBag).includes('website'))}"
              >
            </div>

            <div class="col-12 pb-2" v-for="(langCode, index) in options.available_languages" :key="index">
              <label :for="'description_'+index" class="col-form-label">
                {{ $t("flexben.general.description") }} - {{ langCode }}
              </label>
              <span
                :id="'description_tooltip_'+index"
                class="d-inline-block flexben-tooltip-icon ml-2 text-bold"
              >
                i
              </span>
              <b-tooltip :target="'description_tooltip_'+index" variant="flexben" placement="topleft">
                <div class="text-left">{{ $t("flexben.brand.tooltips.description") }}</div>
              </b-tooltip>
              <p v-if="Object.keys(errorsBag).includes('description.'+langCode)" class="text-danger">
                {{errorsBag['description.'+langCode][0]}}
              </p>
              <v-editor
                :id="'description_'+index" rows="5"
                class="form-control-textarea my-0"
                :placeholder="$t('flexben.brand.fields.description_placeholder')"
                v-model="formData.description[langCode]"
                :editorToolbar="editorToolbar"
                :class="{'border-danger':(Object.keys(errorsBag).includes('description|'+langCode))}"
              />
            </div>

            <div class="col-12 form-group">
              <label for="address" class="col-form-label">
                {{ $t('flexben.brand.fields.scope_availability') }}
              </label>
              <div v-for="(item, key) of options.scope_availability" :key="key" class="d-flex">
                <input
                  type="checkbox"
                  :value="item"
                  :id="'scope_availability_'+item"
                  :checked="formData.scope_availability.includes(item)"
                  @change="toggleScopeAvailability(item)"
                  class="mr-2 cursor-pointer"
                />
                <label :for="'scope_availability_'+item" class="text-14 mb-0 cursor-pointer">
                  {{ $t('flexben.brand.scope_availability.'+item) }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-bg-white mt-3">

    </div>
    <div class="container-bg-white mt-3">
      <div class="row p-3">
        <div class="col-12">
          <h3 class="m-0 pl-0">{{ $t('flexben.partner.assigned_benefits') }}</h3>
        </div>
        <div class="col-12">
          <div class="table-responsive scaled-table">
            <table class="table table-striped">
              <thead>
              <tr>
                <td>{{ $t("flexben.general.name") }}</td>
                <td>{{ $t("flexben.brand.fields.value") }}</td>
                <td>{{ $t("flexben.benefit.fields.sub_type") }}</td>
                <td>{{ $t("flexben.brand.fields.provider") }}</td>
                <td>{{ $t("flexben.benefit.fields.status") }}</td>
                <td>{{ $t("flexben.brand.fields.is_active_app") }}</td>
                <td>{{ $t("flexben.brand.fields.actions") }}</td>
              </tr>
              </thead>
              <tbody v-if="assignedBenefits.length>0">
              <tr v-for="(item, index) in assignedBenefits" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.value }}</td>
                <td>{{ item.sub_type ? $t("flexben.benefit.sub_types." + item.sub_type) : '-'}}</td>
                <td>{{item.provider}}</td>
                <td>
                  <span :class="'benefit-status-'+item.status.toLocaleLowerCase()" class="benefit-status m-0">{{ $t("flexben.general.status_type." + item.status.toLocaleLowerCase()) }}</span>
                </td>
                <td>
                  <span :class="(item.is_available) ? 'benefit-status-active' : 'benefit-status-inactive'" class="benefit-status m-0">
                    {{ (item.is_available) ? $t("flexben.general.status_type.active") : $t("flexben.general.status_type.inactive") }}
                  </span>
                </td>
                <td>
                  <div  class="d-flex justify-content-between" v-if="item.status.toLocaleLowerCase() !== 'inactive'">
                    <div style="display: grid">
                      <label for="address" class="col-form-label pt-0 text-bold form-fields-required">
                        {{ $t('flexben.brand.fields.scope_availability') }}
                      </label>
                      <div>
                        <input
                            type="checkbox"
                            :id="'scope_availability_'+item.id"
                            :checked="isAvailabilityChecked(item)"
                            :disabled="isAvailabilityDisabled(item)"
                            class="mr-2 cursor-pointer"
                            @change="onAvailabilityToggle(item, $event.target.checked)"
                        />
                      </div>
                    </div>
                    <div style="display: grid">
                      <label class="col-form-label pt-0 text-bold form-fields-required"
                             for="start_use_date">{{$t("flexben.offers.fields.start_date")}}</label>
                      <div class="d-inline-flex">
                        <label for="start_use_date" class="my-auto mr-2 col-form-label">
                          <font-awesome-icon icon="calendar-alt" class="text-24 "  :style="{color: item.start_use_date && item.end_use_date ? '#cccccc!important' : '#585858'}"/>
                        </label>
                        <datepicker :format="dateFormat"
                                    v-model="item.start_use_date"
                                    :inputClass="{'form-control-d m-0 w-100 background-white':true, 'border-danger': hasBenefitError(item.id, 'start')}"
                                    :class="{'w-100':true}"
                                    :key="'start-' + item.id + '-' + item._dpKeyStart"
                                    :id="'start_use_date_' + item.id"
                                    :disabledDates="disableUntil"
                                    @opened="setActiveRow(item.id)"
                                    @input="onStartDateChange(item)"
                                    @closed="onStartClosed(item)"
                                    ></datepicker>
                      </div>
                    </div>
                    <div style="display: grid">
                      <label class="col-form-label pt-0 text-bold form-fields-required"
                             for="end_use_date">{{$t("flexben.offers.fields.end_date")}}</label>
                      <div class="d-inline-flex">
                        <label for="end_use_date" class="my-auto mr-2 col-form-label">
                          <font-awesome-icon icon="calendar-alt" class="text-24 "  :style="{color: item.start_use_date && item.end_use_date && activeBenefitId === item.id ? '#cccccc!important' : '#585858'}"/>
                        </label>
                        <div>
                          <datepicker :format="dateFormat"
                                      v-model="item.end_use_date"
                                      :inputClass="{'form-control-d m-0 w-100 background-white':true, 'border-danger': hasBenefitError(item.id, 'end')}"
                                      :class="{'w-100':true}"
                                      :key="'end-' + item.id + '-' + item._dpKeyEnd"
                                      :disabledDates="getEndDisabledDates(item)"
                                      :id="'end_use_date_' + item.id"
                                      @input="onEndDateChange(item)"
                                      @opened="setActiveRow(item.id)"></datepicker>
                          <p v-if="hasBenefitError(item.id, 'end')" class="text-danger mb-0">
                            {{ benefitDateErrors[item.id].end }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style="display: grid">
                      <button
                          v-if="item._dirty"
                          type="button"
                          class="btn action-button justify-content-end h-100"
                          @click="saveBenefitRow(item)"
                      >
                        {{$t("flexben.general.btn.save")}}
                      </button>

                      <button
                          v-if="item._dirty"
                          type="button"
                          class="btn action-button justify-content-end h-100"
                          style="background:#dc3545!important;color:white!important;"
                          @click="revertRow(item)"
                      >
                        {{$t("flexben.requests.action.cancel")}}
                      </button>

                      <button
                          v-else-if="item._serverHasDates || item._serverHasAvailability"
                          type="button"
                          class="btn action-button justify-content-end h-100"
                          style="background:#dc3545!important;color:white!important;"
                          @click="clearRemote(item)"
                      >
                        {{$t("flexben.requests.action.cancel")}}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr class="trhover gri-cell">
                <td class="text-center">{{ $t('flexben.partner.no_assigned_benefits') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
      :action="modal.action"
       :formSuccess="modal.formSuccess"
       :message="modal.message"
       :canDelete="modal.canDelete"
       ref="confirm-modal"
       @confirmAction="confirmAction"
    >
    </confirm-modal>
    <content-loader :loader-visible="this.loading" :loader-error="loaderError" />
  </div>
</template>

<script>
import FormErrorList from "@/components/fragments/FormErrorList";
import httpFlexbenService from "@/http/http-flexben";
import ConfirmModal from "@/components/flexben/brands/modals/ConfirmModal";
import {BTooltip} from "bootstrap-vue";
import {VueEditor} from "vue2-editor";
import vueEditorSettings from "@/constants/vue_editor_settings";
import Datepicker from "vuejs-datepicker";
import moment from "moment/moment";

export default {
  name: "BrandForm",
  components: {
    "form-error-list": FormErrorList,
    "confirm-modal": ConfirmModal,
    'b-tooltip': BTooltip,
    'v-editor': VueEditor,
    'datepicker': Datepicker
  },
  props: {
    itemId: {
      required: false,
      type: Number,
    },
    formAction: {
      type: String,
      required: true,
    },
    options: {
      required: true,
      type: Object,
    },
  },
  data: () => {
    return {
      activeBenefitId: null,
      benefitDateErrors: {},
      dateFormat: 'dd/MM/yyyy',
      disableUntil: {to: moment().startOf('day').toDate()},
      httpService: httpFlexbenService.brandService,
      editorToolbar: vueEditorSettings.editorToolbar,
      loading: false,
      loaderError: false,
      imageChanged: false,
      benefitsCount: 0,
      assignedBenefits: [],
      isFormModified: false,
      formData: {
        id: null,
        name: null,
        website: null,
        image: null,
        image_url: null,
        description: {},
        scope_availability: [],
      },
      modal: {
        action: '',
        formSuccess: true,
        message: '',
        canDelete: true,
      },
      errorsBag: {},
    };
  },
  watch: {
    formData: {
      deep: true,
      handler: function () {
        this.isFormModified = true;
      }
    }
  },
  created() {
    if (!this.itemId) {
      return;
    }

    this.loading = true;

    const instance = this;

    this.httpService.details(this.itemId).then(function (response) {
      response = response.data;
      this.benefitsCount = response.data.benefitsCount;
      if (this.benefitsCount) {
        this.modal.canDelete = false;
      }
      this.formData.name = response.data.brand.name;
      this.formData.website = response.data.brand.website;
      this.formData.image_url = response.data.brand.image_url;
      for (let index in this.options.available_languages) {
        let langCode = this.options.available_languages[index];
        this.formData.description[langCode] = response.data.brand.description
          ? response.data.brand.description[langCode]
          : ''
        ;
      }
      this.formData.scope_availability = response.data.brand.scope_availability ? response.data.brand.scope_availability : [];
    }.bind(this)).then(function () {
      this.isFormModified = false;
      instance.reloadBenefitsTable(instance);
    }.bind(this));
  },
  methods: {
    revertRow(item) {
      const start = (item._initial && item._initial.start_use_date) ? new Date(item._initial.start_use_date) : null;
      const end = (item._initial && item._initial.end_use_date) ? new Date(item._initial.end_use_date) : null;
      const avail = !!item._initial.availability;

      this.$set(item, 'start_use_date', start);
      this.$set(item, 'end_use_date', end);
      this.$set(item, 'availability', avail);

      if (start && end) this.$set(item, 'availability', false);

      item._dirty = false;
      this.$delete(this.benefitDateErrors, item.id);

      this.$nextTick(() => {
        this.$set(item, '_dpKeyStart', (item._dpKeyStart || 0) + 1);
        this.$set(item, '_dpKeyEnd', (item._dpKeyEnd || 0) + 1);
      });
    },
    reloadBenefitsTable(instance) {
      instance.loading = true;
      instance.httpService.getBenefits(this.itemId).then(function (response) {
        instance.assignedBenefits = (response.data.data || []).map(b => {
          const serverHasDates = !!(b.start_use_date && b.end_use_date);
          const serverHasAvailability = !!b.availability && !serverHasDates;

          return {
            ...b,
            _serverHasDates: serverHasDates,
            _serverHasAvailability: serverHasAvailability,
            _dirty: false,
            _dpKeyStart: 1,
            _dpKeyEnd: 1,
            _initial: {
              availability: !!b.availability,
              start_use_date: b.start_use_date ? new Date(b.start_use_date) : null,
              end_use_date: b.end_use_date ? new Date(b.end_use_date) : null,
            },

            start_use_date: b.start_use_date ? new Date(b.start_use_date) : null,
            end_use_date: b.end_use_date ? new Date(b.end_use_date) : null,

            availability: serverHasDates ? false : !!b.availability,
          };
        });

        instance.loading = false;
      })
    },
    onStartClosed(item) {
      item.end_use_date = null;
      this.$set(item, '_dpKeyEnd', (item._dpKeyEnd || 0) + 1); // ca să dispară și din UI
    },
    setActiveRow(benefitId) {
      if (!benefitId) return;

      if (this.activeBenefitId && this.activeBenefitId !== benefitId) {
        this.clearUnsavedDates(this.activeBenefitId);
      }
      this.activeBenefitId = benefitId;
    },

    clearUnsavedDates(benefitId) {
      const row = this.assignedBenefits.find(b => b.id === benefitId);
      if (!row) return;
      if (!row._datesSaved) {
        row.start_use_date = null;
        row.end_use_date = null;
        row.availability = false;
      }
      this.$delete(this.benefitDateErrors, benefitId);
    },

    getEndDisabledDates(item) {
      if (item.start_use_date) {
        return { to: item.start_use_date };
      }
      return this.disableUntil;
    },

    hasBenefitError(benefitId, field) {
      return !!(this.benefitDateErrors[benefitId] && this.benefitDateErrors[benefitId][field]);
    },

    isAvailabilityChecked(item) {
      return !!item.availability && !item.start_use_date && !item.end_use_date;
    },

    isAvailabilityDisabled(item) {
      return !!item.start_use_date || !!item.end_use_date || !!item._serverHasDates;
    },

    onAvailabilityToggle(item, checked) {
      item._dirty = true;

      if (checked) {
        item.start_use_date = null;
        item.end_use_date = null;
        item.availability = true;
      } else {
        item.availability = false;
      }

      this.$delete(this.benefitDateErrors, item.id);
    },

    onStartDateChange(item) {
      item._dirty = true;

      item.end_use_date = null;

      item.availability = false;

      this.$delete(this.benefitDateErrors, item.id);
    },

    onEndDateChange(item) {
      item._dirty = true;
      item.availability = false;
      this.$delete(this.benefitDateErrors, item.id);
    },

    validateRow(item) {
      this.$delete(this.benefitDateErrors, item.id);

      if (item.start_use_date && !item.end_use_date) {
        this.$set(this.benefitDateErrors, item.id, {
          end: this.$t('flexben.brand.errors.end_date'),
        });
        return false;
      }
      return true;
    },

    async saveBenefitRow(item) {
      if (!this.validateRow(item)) return;

      const hasDates = !!(item.start_use_date && item.end_use_date);
      const availability = hasDates ? false : !!item.availability;

      await this.httpService.saveBenefitDatesAvailable(this.itemId, {
        benefit_id: item.id,
        availability,
        start_use_date: item.start_use_date,
        end_use_date: item.end_use_date
      });

      await this.reloadBenefitsTable(this);
    },

    clearLocal(item) {
      this.$set(item, 'start_use_date', null);
      this.$set(item, 'end_use_date', null);
      this.$set(item, 'availability', false);

      this.$set(item, '_dpKeyStart', (item._dpKeyStart || 0) + 1);
      this.$set(item, '_dpKeyEnd', (item._dpKeyEnd || 0) + 1);

      item._dirty = false;
      this.$delete(this.benefitDateErrors, item.id);
    },

    async clearRemote(item) {
      await this.httpService.removeBenefitDatesAvailable(this.itemId, item.id);
      await this.reloadBenefitsTable(this);
    },
    goBack() {
      if (this.isFormModified) {
        this.modalAct('go_back')
      } else {
        this.$emit('clearForm');
      }
    },
    confirmAction(action) {
      if (action === 'go_back') {
        this.isFormModified = false;
        this.goBack();
      }
      this.closeModal();
      if (action === 'form_submit') {
        this.save();
      }
      if (action === 'delete') {
        this.delete();
      }
      if (action === 'end') {
        this.goBack();
      }
    },
    modalAct(action) {
      this.modal.message = '';
      if (action === 'delete' && this.benefitsCount) {
        this.modal.message = this.$t('flexben.brand.modal.extra_delete', {count_benefits: this.benefitsCount});
      }
      this.modal.action = action;
      this.openModal();
    },
    openModal() {
      this.$refs['confirm-modal'].openModal();
    },
    closeModal() {
      this.$refs['confirm-modal'].closeModal();
    },
    _prepareFormData() {
      let formData = new FormData();
      if (this.formData.name) {
        formData.append('name', this.formData.name);
      }
      if (this.formData.website) {
        formData.append('website', this.formData.website);
      }
      if (this.formData.image) {
        formData.append('image', this.formData.image);
      }
      formData.append('description', JSON.stringify(this.formData.description));
      formData.append('scope_availability', JSON.stringify(this.formData.scope_availability));

      return formData;
    },
    save() {
      this.loading = true;
      this.httpService.save(this.itemId, this._prepareFormData())
        .then(function () {
          this.modal.formSuccess = true;
          this.modal.action = 'end';
          this.loading = false;
          this.isFormModified = false;
          this.openModal();
        }.bind(this))
        .catch(function (error) {
          if (error.response.status === 400) {
            this.errorsBag = error.response.data.error_fields;
            this.modal.formSuccess = false;
            this.modal.message = this.$t('flexben.general.validation_errors');
            this.modal.action = 'end';
            this.loading = false;
            this.openModal();
          } else {
            this.loading = false;
            this.loaderError = true;
          }
        }.bind(this));
    },
    delete() {
      this.loading = true;
      this.httpService.delete(this.itemId)
        .then(function (response) {
          this.modal.formSuccess = true;
          this.modal.action = 'end';
          this.modal.message = '';
          this.loading = false;
          this.openModal();
        }.bind(this))
        .catch(function (error) {
          if (error.response.status === 400) {
            this.loading = false;
            this.loaderError = true;
          }
        }.bind(this));
    },
    setImageFile() {
      this.errorsBag = {};
      if (this.$refs.image_input.accept.indexOf(this.$refs.image_input.files[0].type.split('/')[1]) > 0) {
        let reader = new FileReader();
        reader.readAsDataURL(this.$refs.image_input.files[0]);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            if (img.width !== img.height) {
              this.errorsBag = {image: 'image_square'};
            } else if (img.width !== 500 || img.height !== 500) {
              this.errorsBag = {image: 'image_500_500'};
            } else {
              this.formData.image = this.$refs.image_input.files[0];
              this.imageChanged = true;
              if (typeof this.formData.image !== "undefined") {
                this.imagePreview = URL.createObjectURL(this.formData.image);
              }
            }
          }
          img.src = evt.target.result;
        }
      } else {
        this.errorsBag = {image: 'image_type_supported'};
      }
    },
    toggleScopeAvailability(item) {
      if (this.formData.scope_availability.includes(item)) {
        this.formData.scope_availability.splice(this.formData.scope_availability.indexOf(item), 1);
      } else {
        this.formData.scope_availability.push(item);
      }
    },
    remove(benefit_id) {
      this.loading = true;
      this.httpService.removeBenefitDatesAvailable(this.itemId, benefit_id).then(response => {
        this.reloadBenefitsTable(this);
        this.loading = false;
      });
    }
  },
}
</script>
